class Calendar {
    weekdaysDefault = [0, 1, 2, 3, 4, 5, 6]
    intervalsDefault = {
        first: 0,
        minutes: 60,
        count: 24,
        height: 40
    }
    stylings = {
        default () {
            return undefined
        },
        workday (interval) {
            const inactive = interval.weekday === 0 ||
            interval.weekday === 6 ||
            interval.hour < 9 ||
            interval.hour >= 17
            const startOfHour = interval.minute === 0
            const dark = this.dark
            const mid = dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'

            return {
            backgroundColor: inactive ? (dark ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.05)') : undefined,
            borderTop: startOfHour ? undefined : '1px dashed ' + mid
            }
        },
        past (interval) {
            return {
            backgroundColor: interval.past ? (this.dark ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.05)') : undefined
            }
        }
    }
    picker= false
    dark= false
    startMenu= false
    start=  new Date().toISOString().substr(0, 10)
    changeDateDaftarPaien = new Date().toISOString().substr(0, 10)
    endMenu= false
    end= ''
    nowMenu= false
    minWeeks= 1
    now= null
    type= 'day'
    typeOptions= [
      { text: 'Day', value: 'day' },
      { text: '4 Day', value: '4day' },
      { text: 'Week', value: 'week' },
      { text: 'Month', value: 'month' },
      { text: 'Custom Daily', value: 'custom-daily' },
      { text: 'Custom Weekly', value: 'custom-weekly' }
    ]
    weekdays= this.weekdaysDefault
    weekdaysOptions= [
      { text: 'Sunday - Saturday', value: this.weekdaysDefault },
      { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
      { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] }
    ]
    intervals= this.intervalsDefault
    intervalsOptions= [
      { text: 'Default', value: this.intervalsDefault },
      { text: 'Workday', value: { first: 16, minutes: 30, count: 20, height: 40 } }
    ]
    maxDays= 7
    maxDaysOptions= [
      { text: '7 days', value: 7 },
      { text: '5 days', value: 5 },
      { text: '4 days', value: 4 },
      { text: '3 days', value: 3 }
    ]
    styleInterval= 'default'
    styleIntervalOptions= [
      { text: 'Default', value: 'default' },
      { text: 'Workday', value: 'workday' },
      { text: 'Past', value: 'past' }
    ]
    color = 'primary'
    
    intervalStyle () {
        return this.stylings[ this.styleInterval ].bind(this)
    }
    hasIntervals () {
        
        return this.type in {
        'week': 1, 'day': 1, '4day': 1, 'custom-daily': 1
        }
    }
    hasEnd () {
        return this.type in {
        'custom-weekly': 1, 'custom-daily': 1
        }
  }
  
  formatTgl(value) {
    const dd = value.substr(0, 2);
    const mm = value.substr(3, 2);
    const yyyy = value.substr(6, 4);
    // return dd + "-" + mm + "-" + yyyy;
    return yyyy + "-" + mm + "-" + dd;
  }
  
  formatTgl2(value) {
    const dd = value.substr(8, 2);
    const mm = value.substr(5, 2);
    const yyyy = value.substr(0, 4);
    return dd + "-" + mm + "-" + yyyy;
    // return yyyy + "-" + mm + "-" + dd;
  }
}
export default new Calendar();